{
  "nav.today": "Today",
  "nav.workspaces": "Workspaces",
  "nav.initiatives": "Initiatives",
  "nav.plans": "Plans",
  "nav.runs": "Runs",
  "cta.run": "Run",
  "cta.approve": "Approve",
  "cta.reject": "Reject",
  "cta.retry": "Retry",
  "state.loading": "Loading\u2026",
  "state.empty": "Nothing here yet.",
  "state.unknown": "Unknown",
  "state.unnamed": "Unnamed",
  "state.untitled": "Untitled",
  "state.not-set": "(not set)",
  "state.never": "Never",
  "state.not-set-label": "Not set",
  "admin.cost-cap.approved": "Spending limit increase approved.",
  "admin.delete-data.my-workspace": "my workspace",
  "auth.callback.operator": "Operator",
  "auth.callback.administrator": "Administrator",
  "auth.signin.failed": "Sign-in failed",
  "auth.onboarding.not-set": "(not set)",
  "landing.feature.refinement": "Multi-pass PRD refinement with convergence detection, cost caps, and operator playbooks.",
  "landing.feature.realtime": "Live decision queues, run observers, and workspace conversations powered by reactive subscriptions.",
  "landing.feature.analytics": "Spending analytics, quality alerts, CI health, friction reports, and team capacity dashboards.",
  "initiative.briefs.unnamed-brief": "Unnamed brief",
  "initiative.briefs.unnamed-asset": "Unnamed asset",
  "initiative.launch.unnamed": "Unnamed",
  "keys.save-access-key": "Save this access key",
  "keys.save-rotated-key": "Save this rotated access key",
  "keys.status": "Status",
  "showcase.run-started": "Run started",
  "showcase.decision-pending": "Decision pending",
  "showcase.run-completed": "Run completed",
  "showcase.brief-submitted": "Brief submitted",
  "showcase.webhook-delivered": "Webhook delivered",
  "showcase.build-passed": "Build passed",
  "perimeter.detail": "Detail",
  "today.admin": "Admin",
  "today.operator": "Operator",
  "today.decisions.pending": "Decision pending",
  "today.spend.label": "Spend",
  "brief.select": "Select\u2026",
  "brief.save-failed": "Save failed. Please try again.",
  "brief.save-first": "Save the brief first",
  "run.converged": " (converged)",
  "run.cancelled": "Run cancelled",
  "run.reason-too-long": "Reason text is too long (max 4096 characters)",
  "run.cancel-failed": "Could not cancel this run. Try again.",
  "workspace.untitled-conversation": "Untitled conversation",
  "workspace.unnamed-refinement": "Unnamed refinement",
  "component.processing": "Processing...",
  "component.refinement-disabled": "Refinements are temporarily disabled. Contact an admin.",
  "component.generic-error": "Something went wrong. Please try again.",
  "component.see-all": "See all",
  "component.loading": "Loading",
  "component.loading-ellipsis": "Loading...",
  "component.loading-more": "Loading more content",
  "component.live": "Live",
  "phase.exploration": "Exploration",
  "phase.planning": "Planning",
  "phase.implementation": "Implementation",
  "phase.verification": "Verification",
  "phase.delivery": "Delivery"
}
